import { forwardRef } from "react";
import React from "react";
import { Icon, IconNames } from "../Common/Icons/LucideIcons";
import { Body } from "../Common/Typography";
import {
  CommonContentTextBlock,
  CommonContentWrapper,
  GroupWrapper,
  LucideIconWrapper,
  StyledSelectionCard,
} from "./__styles__/SelectionCard";

export const SelectionCardItem = forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof StyledSelectionCard>
>((props, forwardedRef) => {
  return (
    <StyledSelectionCard {...props} ref={forwardedRef}>
      {props.children}
    </StyledSelectionCard>
  );
});
const SelectionCardGroup = forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof GroupWrapper>
>((props, forwardedRef) => {
  return (
    <GroupWrapper {...props} ref={forwardedRef}>
      {props.children}
    </GroupWrapper>
  );
});

const SelectionCardCommonContent = ({
  iconName,
  title,
  description,
  disabled = false,
}: {
  iconName?: IconNames;
  title?: Maybe<string>;
  description?: Maybe<string>;
  disabled?: boolean;
}) => (
  <CommonContentWrapper>
    {iconName && (
      <LucideIconWrapper>
        <Icon
          iconName={iconName}
          color={disabled ? "contentDisabled" : "contentSecondary"}
          size={16}
        />
      </LucideIconWrapper>
    )}
    {(title || description) && (
      <CommonContentTextBlock>
        {title && (
          <Body
            size="default"
            type="emphasis"
            color={disabled ? "contentDisabled" : "contentPrimary"}
          >
            {title}
          </Body>
        )}
        {description && (
          <Body
            color={disabled ? "contentDisabled" : "contentSecondary"}
            size="default"
            type="regular"
          >
            {description}
          </Body>
        )}
      </CommonContentTextBlock>
    )}
  </CommonContentWrapper>
);

export const SelectionCard = {
  Group: SelectionCardGroup,
  Item: SelectionCardItem,
  Content: SelectionCardCommonContent,
};
